import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * SparkLab Icon
 *
 * @file SparkLab.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const SparkLab = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <g fill="none">
      <path
        d="M6.4447 1.74561V5.94979C6.4447 6.28498
            6.3647 6.62016 6.2247 6.9362L3.0547 13.8219C2.7347
            14.521 2.8647 15.3254 3.3947 15.8904L3.6847
            16.1969C4.0647 16.6087 4.6147 16.8385 5.1847
            16.8385H12.8147C13.6047 16.8385 14.3347 16.465
            14.7747 15.8426C15.1647 15.2967 15.2247 14.588
            14.9447 13.9847L11.8747 7.30011C11.6247 6.75424
            11.4947 6.16048 11.4947 5.55715V1.74561H6.4447Z"
        stroke="currentcolor"
        strokeWidth="1.75"
        strokeMiterlimit="10"
      />
      <path
        d="M12.6347 1.16162H5.3647C5.0847 1.16162 4.8647
            1.37231 4.8647 1.64046C4.8647 1.90861 5.0847 2.11929
            5.3647 2.11929H12.6247C12.9047 2.11929 13.1247 1.90861
            13.1247 1.64046C13.1347 1.37231 12.9047 1.16162
            12.6347 1.16162Z"
        fill="currentcolor"
        stroke="currentcolor"
        strokeMiterlimit="10"
      />
      <path
        d="M6 9.34131C6.35521 9.61844 6.89462 9.94549 7.54585
            10.0315C8.70879 10.175 9.27522 9.41707 10.3345
            9.22404C10.9615 9.111 11.866 9.17287 13.0404
            9.99897"
        stroke="currentcolor"
        strokeWidth="1.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <circle cx="10.6336" cy="12.3171" r="0.925" fill="currentcolor" />
      <circle cx="7.52161" cy="13.8496" r="1.25" fill="currentcolor" />
    </g>
  </SvgIcon>
);

export default SparkLab;
